(() => {
  document.addEventListener(
    'click',
    async (event) => {
      const submitButton = event.target.closest('product-recommendations product-form [type="submit"]');
      if (!submitButton || submitButton.getAttribute('aria-disabled') === 'true') return;

      const productForm = submitButton.closest('product-form');
      const form = productForm?.querySelector('form');
      const cartDrawer = document.querySelector('cart-drawer');
      if (!form || !cartDrawer) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
      submitButton.querySelector('.loading__spinner')?.classList.remove('hidden');

      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(form);
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map((section) => section.id),
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        cartDrawer.setActiveElement(submitButton);

        const response = await fetch(routes.cart_add_url, config);
        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Unable to add this product to the cart.');
        }

        cartDrawer.renderContents(result);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'related-products',
            productVariantId: formData.get('id'),
            cartData: result,
          });
        }
      } catch (error) {
        console.error('Related product add to cart failed.', error);
      } finally {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        submitButton.querySelector('.loading__spinner')?.classList.add('hidden');
        cartDrawer.classList.remove('is-empty');
      }
    },
    true,
  );
})();
